// Checagem LEVE do formato da chave pública SSH colada na tela (PO1-2167). Só para o
// operador ver na hora que colou a coisa errada; quem valida de verdade (blob, tamanho da
// RSA, tipo declarado × tipo do blob) é o backend (functions/sshKey.js).

export const TIPOS_ACEITOS = ["ssh-rsa", "ssh-ed25519"];
export const MAX_CHAVES = 3;

const INICIO_SSH2 = "---- BEGIN SSH2 PUBLIC KEY ----";
const FIM_SSH2 = "---- END SSH2 PUBLIC KEY ----";
const BASE64 = /^[A-Za-z0-9+/]+={0,2}$/;

export function pareceChavePublica(texto) {
  const t = String(texto || "").trim();
  if (!t) return { ok: false, motivo: "Cole a chave pública." };

  if (t.indexOf(INICIO_SSH2) === 0) {
    if (t.indexOf(FIM_SSH2) < 0) return { ok: false, motivo: "Bloco SSH2 sem a linha de fim." };
    const corpo = t
      .slice(INICIO_SSH2.length, t.indexOf(FIM_SSH2))
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter((l) => l && !/^[A-Za-z0-9-]+:/.test(l))
      .join("");
    if (!corpo || !BASE64.test(corpo)) return { ok: false, motivo: "Conteúdo do bloco SSH2 não parece base64." };
    return { ok: true, tipo: "ssh2", formato: "RFC 4716" };
  }

  const partes = t.split(/\s+/);
  if (partes.length < 2) return { ok: false, motivo: "Esperado: <tipo> <base64> [comentário]." };
  const [tipo, blob] = partes;
  if (TIPOS_ACEITOS.indexOf(tipo) < 0) {
    return { ok: false, motivo: `Tipo ${tipo} não aceito (aceitos: ${TIPOS_ACEITOS.join(", ")}).` };
  }
  if (blob.length < 40 || !BASE64.test(blob)) return { ok: false, motivo: "Parte em base64 inválida." };
  if (/PRIVATE KEY/.test(t)) return { ok: false, motivo: "Isso é uma chave PRIVADA. Cole só a pública." };
  return { ok: true, tipo, formato: "OpenSSH" };
}

export function nomeChaveValido(nome) {
  return /^[A-Za-z0-9 _.-]{1,40}$/.test(String(nome || "").trim());
}
